import React, { PropsWithChildren, useCallback, useState } from 'react';
import Snackbar, {
  SNACKBAR_TIMEOUT,
} from 'shared/components/vxl/Snackbar/Snackbar';
import { useAutoHideSnackbar } from 'shared/hooks/snackBar/useAutoHideSnackbar';

export type GlobalUIContextProps = {
  setSnackBarMessage?: (message: string) => void;
};

export const GlobalUIContext = React.createContext<GlobalUIContextProps>({});

/**
 * this context draws UI that persists across multiple screens in the app, for example the snack bar.
 */
const GlobalUIContextProvider = ({ children }: PropsWithChildren) => {
  const [snackBarMessage, setSnackBarMessage] = useState<string>('');

  useAutoHideSnackbar(
    Boolean(snackBarMessage),
    () => {
      setSnackBarMessage('');
    },
    SNACKBAR_TIMEOUT,
  );

  return (
    <GlobalUIContext.Provider
      value={{
        setSnackBarMessage: useCallback(
          (message: string) => setSnackBarMessage(message),
          [],
        ),
      }}
    >
      {children}
      {snackBarMessage ? (
        <Snackbar text={snackBarMessage} duration={SNACKBAR_TIMEOUT} />
      ) : null}
    </GlobalUIContext.Provider>
  );
};

export default GlobalUIContextProvider;
